import isNil from "lodash/isNil";

import { FilterQuery } from "shared";

export const getHasFiltersParams = (filtersParams: FilterQuery | undefined): boolean => {
  return !!filtersParams?.filterGroup.expressions.filter((expression) => !isNil(expression.value))
    .length;
};
